<app-page-header></app-page-header>
<app-breadcromb pageName="Dashboard"></app-breadcromb>
<!-- Candidate Dashboard Area Start -->
<section class="candidate-dashboard-area section_70">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-md-12 dashboard-left-border">
        <div class="dashboard-left">
          <app-client-dashboard-sidebar></app-client-dashboard-sidebar>
        </div>
      </div>
      <div class="col-lg-9 col-md-12">
        <div class="dashboard-right">
          <div class="welcome-dashboard">
            <h3>Welcome {{user.username}} !</h3>
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-12 col-sm-12">
              <div class="widget_card_page grid_flex widget_bg_blue">
                <div class="widget-icon">
                  <i class="fa fa-hourglass-half"></i>
                </div>
                <div class="widget-page-text">
                  <h4>{{statistics.pending}}</h4>
                  <h2>Pending Job Status</h2>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12">
              <div class="widget_card_page grid_flex  widget_bg_purple">
                <div class="widget-icon">
                  <i class="fa fa-ban"></i>
                </div>
                <div class="widget-page-text">
                  <h4>{{statistics.declined}}</h4>
                  <h2>Jobs Declined</h2>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12">
              <div class="widget_card_page grid_flex widget_bg_dark_red">
                <div class="widget-icon">
                  <i class="fa fa-users"></i>
                </div>
                <div class="widget-page-text">
                  <h4>{{statistics.applications}} </h4>
                  <h2>Jobs Applied</h2>
                </div>
              </div>
            </div>
            <!--<div class="col-md-4 col-sm-4 mb">
             <div class="grey-panel pn donut-chart">
               <div class="grey-header">
                 <h5>Profile Strength</h5>
               </div>
               <div class="progress">
                <div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 80%">
                  <span class="sr-only">80% Complete (success)</span>
                </div>
              </div>
               &lt;!&ndash;div id="mychart">
                <canvas id="doughnut" height="120" width="120"></canvas>
               <script>
                 var doughnutData = [{
                     value: 70,
                     color: "#fdfdfd"
                   },
                   {
                     value: 30,
                     color: "#fdfdfd"
                   }
                 ];
                 var myDoughnut = new Chart(document.getElementById("doughnut").getContext("2d")).Doughnut(doughnutData);
               </script>
               <div class="row">
                <div class="col-sm-6 col-xs-6 goleft">
                  <p>Completeness:</p>
                </div>
                <div class="col-sm-6 col-xs-6">
                  <h2>21%</h2>
                </div>
              </div&ndash;&gt;
             </div>
             </div>
             </div>-->
          </div>
          <br>


          <div class="row">
            <div class="col-md-12">
              <div class="profile-strength">
                <!-- /.profile-strength-label -->
                <!-- profile-strength item -->
                <div class="time-label">
                  <span *ngIf="!profileCompleted" class="bg-red"
                        style="color:#DDDDDD;">Your profile is incomplete. Please complete your profile.</span>
                  <span *ngIf="profileCompleted" class="bg-green"
                        style="color:#DDDDDD;">Your profile is complete.You can update any time.</span>
                </div>
                <div *ngFor="let prof of profile">
                  <i *ngIf="prof.completed" class="fa fa-check fa-4x bg-green" style="color:#DDDDDD;"></i>
                  <i *ngIf="!prof.completed" class="fa fa-spinner fa-spin fa-4x fa-fw bg-red"
                     style="color:#DDDDDD;"></i>
                  <div class="profile-strength-item">
                    <span *ngIf="prof.completed" class="time"><a href="#" [routerLink]="prof.createUrl"><i class="fa fa-pencil fa-2x"
                                                                                            style="color:#28a745;"></i></a></span>
                    <span *ngIf="!prof.completed" class="time"><a href="#" [routerLink]="prof.createUrl"><i class="fa fa-plus fa-2x"
                                                                                             style="color:#28a745;"></i></a></span>
                    <h3 class="profile-strength-header no-border"><a href="#">{{prof.name}}</a></h3>
                    <div class="profile-strength-body">
                      {{prof.comment}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Candidate Dashboard Area End -->

